import axios from 'axios'
import { API_ADDRESS } from 'config'
import { ScrapingOwner } from 'state/types'

export const getOwnerStats = async (state = ''): Promise<ScrapingOwner[]> => {
  const url = state.length > 0 ? `${API_ADDRESS}/admin/scraping/list-owners?state=${state}` : `${API_ADDRESS}/admin/scraping/list-owners`
  const { data } = await axios.get(url)

  return data
}
